// src/analytics.js
import ReactGA from "react-ga4";

// Initialize Google Analytics with your GA4 Measurement ID
export const initGA = () => {
  ReactGA.initialize("G-8HVLVY5X5N"); // Replace with your actual GA4 ID
};

// Track a page view
export const trackPageView = (path) => {
  ReactGA.send({
    hitType: "pageview",
    page: path,
  });
};

// Track a custom event
export const trackEvent = ({ category, action, label, value }) => {
  ReactGA.event({
    category,
    action,
    label,
    value,
  });
};
